import { TFunction } from 'i18next'

export type ReservationValidationError =
  | {
      type: 'groupMinQty'
      groupId: number
      groupName: string
      minQty: number
    }
  | {
      type: 'groupMaxQty'
      groupId: number
      groupName: string
      maxQty: number
    }
  | {
      type: 'globalMinQty'
      minQty: number
    }
  | {
      type: 'globalMaxQty'
      maxQty: number
    }

export function getReservationValidationErrorLine(
  t: TFunction,
  error: ReservationValidationError
): string {
  switch (error.type) {
    case 'groupMinQty':
      return t('reservationValidation.groupMinQty', {
        groupName: error.groupName,
        min: error.minQty,
      })
    case 'groupMaxQty':
      return t('reservationValidation.groupMaxQty', {
        groupName: error.groupName,
        max: error.maxQty,
      })
    case 'globalMinQty':
      return t('reservationValidation.globalMinQty', {
        count: error.minQty,
        min: error.minQty,
      })
    case 'globalMaxQty':
      return t('reservationValidation.globalMaxQty', {
        count: error.maxQty,
        max: error.maxQty,
      })
    default:
      return ''
  }
}

export function formatReservationValidationMessage(
  t: TFunction,
  errors: ReservationValidationError[]
): { lines: string[]; title: string | null } {
  const lines = errors
    .map((error) => getReservationValidationErrorLine(t, error))
    .filter(Boolean)

  if (lines.length === 0) {
    return { lines: [], title: null }
  }

  if (lines.length === 1) {
    return { lines: [], title: lines[0] }
  }

  return {
    lines,
    title: t('reservationValidation.multipleTitle'),
  }
}

export function getReservationValidationToastMessage(
  t: TFunction,
  errors: ReservationValidationError[]
): string {
  const { lines, title } = formatReservationValidationMessage(t, errors)

  if (!title) {
    return ''
  }

  if (lines.length === 0) {
    return title
  }

  return `${title} ${lines.join(' · ')}`
}
